import { CurrencyRupeeIcon } from './CurrencyRupeeIcon';

/**
 * author: Google
 * id 4C5FB412-6649-4F26-A075-2865BAF41B5F
 * name currency-rupee
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-rupee.svg
 * tags
 * - Banking 
 * - Currency 
 */
export const CurrencyNprIcon = CurrencyRupeeIcon;
export default CurrencyNprIcon